<template>
  <b-modal
    :id="id"
    :dialog-class="modalData?.className"
    scrollable
    hide-header
    hide-header-close
    hide-footer
    centered
    :no-close-on-esc="modalData?.noClose"
    :no-close-on-backdrop="modalData?.noClose"
    @hide="$emit('hide')"
    @hidden="$emit('hidden')"
  >
    <div v-if="0 < modalData?.title?.length" class="title" v-html="modalData?.title" />
    <div v-if="0 < modalData?.content?.length" class="base-modal-content" v-html="modalData?.content" />
    <button v-if="modalData?.closeBtn" class="close-btn" @click="() => $bvModal.hide(id)">
      <img :src="`${$s3}/img/common/modal/${modalData?.closeBtn}.webp?${$ver}`" />
    </button>
    <slot />
    <div v-if="modalData?.btns" class="btn-wrapper" :class="{ 'cancel-on': modalData?.cancel && modalData?.submit }">
      <button
        v-if="modalData?.cancel"
        id="modal-cancel-btn"
        class="modal-btn cancel"
        :disabled="cancelDisabled"
        @click="modalData?.cancel()"
      >
        {{ modalData?.cancelTxt }}
      </button>
      <button
        v-if="modalData?.submit"
        id="modal-confirm-btn"
        class="modal-btn confirm"
        :disabled="submitDisabled"
        @click="modalData?.submit()"
      >
        {{ modalData?.submitTxt }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalData: {},
      cancelDisabled: false,
      submitDisabled: false,
    };
  },
  methods: {
    open(data) {
      const { className, title, closeBtn, noClose, content } = data ?? {};
      const { btns, cancel, cancelTxt, submit, submitTxt } = data ?? {};

      const modalData = {
        className: className ?? 'base-modal',
        title: title ?? '',
        content: content ?? '',
        noClose: noClose ?? false,
        closeBtn: closeBtn ?? false,
        btns: btns ?? true,
        cancel: cancel ?? this.hide,
        cancelTxt: cancelTxt ?? this.$t('modal.cancel'),
        submit: submit ?? this.hide,
        submitTxt: submitTxt ?? this.$t('modal.confirm'),
      };

      this.modalData = { ...modalData };

      this.$bvModal.show(this.id);
    },
    hide() {
      this.$bvModal.hide(this.id);
    },
    setDisabled({ cancelDisabled, submitDisabled }) {
      this.cancelDisabled = cancelDisabled ?? false;
      this.submitDisabled = submitDisabled ?? false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

button.close-btn {
  position: absolute;
  padding: 0;
  right: 16px;
  top: 16px;

  img {
    width: 16px;
  }
}
.modal-dialog.base-modal {
  .modal-content .modal-body {
    .title {
      @include tablet {
        padding: 22px 22px 0;
      }
    }
    .base-modal-content {
      word-break: keep-all;
      padding: 14px 28px 0;

      @include tablet {
        padding: 10px 22px 0;
      }

      ::v-deep {
        span {
          &.blue {
            color: #0e69dc;
          }
          &.red {
            color: #d1221a;
          }
        }
      }
    }
  }
}
.btn-wrapper button.modal-btn {
  padding: 0;
  box-sizing: border-box;
  outline: 0px solid transparent;

  &:focus {
    outline: 3px solid #3c7eea8a;

    &.cancel {
      outline: 3px solid #9999998a;
    }
  }

  &:disabled {
    cursor: default !important;
    background: #ededed !important;
    color: #aaaaaa !important;
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/views/Events/NYCOpenEvent/modal.scss';
@import '@/views/Events/WhitePaper/modal.scss';

@import '@/views/Events/Bookmark/modal.scss';

.modal-dialog.base-modal {
  &.common-modal {
    max-width: 500px;
    margin: 0 auto;
    line-height: 1.2;

    @include mobile {
      min-width: 320px;
      max-width: 95%;
    }
  }
  .modal-content {
    .modal-body {
      background: #ffffff;
    }
  }
}
</style>
